import React from 'react';
import { IconButton } from '@mui/material';
import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded';

/**
 * The chevron that folds a paper away, pointing up while its contents are shown.
 *
 * @param {Object} props - Component props.
 * @param {Boolean} props.collapsed - Whether the contents are hidden.
 * @param {Function} props.onToggle - Called when the chevron is pressed.
 * @param {Boolean} props.disabled - Renders the button unusable.
 *
 * @returns {React.JSX.Element}
 */
const CollapseToggle = function CollapseToggle({
  collapsed = false,
  onToggle = () => {},
  disabled = false,
}) {
  return (
    <IconButton id="toggle-paper" onClick={onToggle} disabled={disabled}>
      <KeyboardArrowDownRoundedIcon
        sx={{
          transform: collapsed ? 'none' : 'rotate(180deg)',
          transition: 'transform 0.3s ease',
        }}
      />
    </IconButton>
  );
};

export default CollapseToggle;
